"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableFormSanitization = exports.sanitizeString = void 0;
const REPLACEMENT_SYMBOL = '';
const formFieldIdsForSanitization = ['givenName', 'surname', 'telephoneNumber', 'extension_companyName', 'streetAddress', 'city', 'postalCode', 'VerificationCode'];
const sanitizeString = string => string.replace(/[&<>"()?{}:;'`=\\/]/g, () => REPLACEMENT_SYMBOL);
exports.sanitizeString = sanitizeString;
const sanitizeInput = elementId => {
  const inputElement = document.getElementById(elementId);
  if (inputElement) {
    inputElement.addEventListener('input', e => {
      e.target.value = (0, exports.sanitizeString)(e.target.value);
    });
  }
};
const enableFormSanitization = () => formFieldIdsForSanitization.forEach(sanitizeInput);
exports.enableFormSanitization = enableFormSanitization;
//# sourceMappingURL=sanitizer.js.map